import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

let accessToken: string | null = null;

export function setSupabaseAccessToken(token: string | null) { accessToken = token; }
export function getSupabaseAccessToken() { return accessToken; }

export const isSupabaseConfigured = Boolean(url && anonKey && !url.includes("your-project"));
export const supabase = isSupabaseConfigured ? createClient(url!, anonKey!, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  global: {
    fetch: (input, init = {}) => {
      const headers = new Headers(init.headers);
      if (accessToken) headers.set("Authorization", `Bearer ${accessToken}`);
      return fetch(input, { ...init, headers, cache: "no-store" });
    },
  },
}) : null;
